export default "__VITE_ASSET__Bip$Yn_T__"